<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>

export default {
	name: 'app',
}	
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Exo:400,700,900');
	@import 'assets/scss/reset';
	@import 'assets/scss/main';

</style>
